import React, { useState, useEffect } from 'react'
import ReactTable from 'react-table'
import numeral from 'numeral'
import _ from 'lodash'
import {
  Div, H4, P, SmallText, Loading, Button as KonsysButton,
} from 'konsys-ui'
import {
  Row, Modal, Col, Upload, message, Select, Button, Icon,
} from 'antd'
import { useQuery, useMutation } from '@apollo/react-hooks'
import {
  TIRE_SERIAL_NUMBER_LIST, TIRE_INVENTORY, WAREHOUSES,
} from '../../../constants/graph/query'
import { IMPORT_TIRE, UPDATE_INVENTORY, MULTIPLETRANSFER_TIRE } from '../../../constants/graph/mutation'
import { theme } from '../../../styles/_variables'
import { Wrapper, DropdownSelector } from '../../../components/tire-inventory-components'
import {
  LargeTextWithLabel, Tag, Collapse, Divider, ComponentWithLabelLarge,
} from '../../../components/common'
import { Image, PartImage } from '../styled'
import { SALE_TYPE, STATUSTEXTSELECTOR } from '../constants'
import { productGroupIdtoText, stockTypeIdtoText } from '../utils'
import imageNotAvailable from '../../../assets/image-not-available.png'
import content, { columnConfig } from './contentForSerialTable'
import { TRANSPORT_WAREHOUSE_ID } from '../../inventory-page/constants'

const { color } = theme

const Info = ({
  data: {
    sku, supplier, productName, brand, productGroup, category, stockType, barcode, reference, Tire, inventoryOptions, technicianName, unit,
  },
}) => (
    <Div width='100%'>
      <Row type='flex' style={{ margin: '16px 0' }}>
        <Col span={8}>
          <LargeTextWithLabel title={{ text: 'รหัสสินค้า' }} content={{ text: sku || 'ไม่ระบุ' }} />
        </Col>
        <Col span={16}>
          <Div display='flex' flexDirection='column'>
            <SmallText bold>Supplier</SmallText>
            <SmallText>{_.join(supplier.map(v => v.name), ', ')}</SmallText>
          </Div>
          {/* <LargeTextWithLabel title={{ text: 'Supplier' }} content={{ text: supplier.name || 'ไม่ระบุ' }} /> */}
        </Col>
      </Row>
      <Row type='flex' style={{ margin: '16px 0' }}>
        <Col span={8}>
          <LargeTextWithLabel title={{ text: 'ชื่อสินค้า' }} content={{ text: productName || 'ไม่ระบุ' }} />
        </Col>
        <Col span={8}>
          <LargeTextWithLabel title={{ text: 'ชื่อที่ช่างเรียก' }} content={{ text: technicianName || 'ไม่ระบุ' }} />
        </Col>
        <Col span={8}>
          <LargeTextWithLabel title={{ text: 'หน่วย' }} content={{ text: unit || 'ไม่ระบุ' }} />
        </Col>
      </Row>
      <Row type='flex' style={{ margin: '16px 0' }}>
        <Col span={8}>
          <LargeTextWithLabel title={{ text: 'ยื่ห้อ' }} content={{ text: brand || 'ไม่ระบุ' }} />
        </Col>
        <Col span={8}>
          <LargeTextWithLabel title={{ text: 'ประเภทยาง' }} content={{ text: Tire && Tire.TireType ? Tire.TireType.name : 'ไม่ระบุ' }} />
        </Col>
      </Row>
      {
        inventoryOptions[0]
        && <Div display='flex' justifyContent='space-between' alignItems='center'>
          <Div display='flex' flexDirection='column' alignItems='flex-start' flexGrow='1'>
            <Col span={6} style={{ margin: '0 0 8px 0' }}>
              <LargeTextWithLabel title={{ text: 'หน้ายาง' }} content={{ text: inventoryOptions[0].option1 ? inventoryOptions[0].option1.optionName : 'ไม่ระบุ' }} />
            </Col>
            <Col span={6} style={{ margin: '0 0 8px 0' }}>
              <LargeTextWithLabel title={{ text: 'แก้มยาง' }} content={{ text: inventoryOptions[0].option2 ? inventoryOptions[0].option2.optionName : 'ไม่ระบุ' }} margin='0 40px 0 0' />
            </Col>
            <Col span={6} style={{ margin: '0 0 8px 0' }}>
              <LargeTextWithLabel title={{ text: 'กะทะล้อ' }} content={{ text: inventoryOptions[0].option3 ? inventoryOptions[0].option3.optionName : 'ไม่ระบุ' }} />
            </Col>
            <Div type='flex' width='100%'>
              <Col span={6} style={{ margin: '0 0 8px 0' }}>
                <LargeTextWithLabel title={{ text: 'จำนวนสินค้า' }} content={{ text: _.sumBy(inventoryOptions[0].stockLocation, n => (n.quantity)) }} margin='0 40px 0 0' />
              </Col>
              <Col span={6} style={{ margin: '0 0 8px 0' }}>
                <LargeTextWithLabel title={{ text: 'จำนวนสต๊อกขั้นต่ำ' }} content={{ text: inventoryOptions[0].minimumStock }} />
              </Col>
            </Div>
            <Div type='flex' width='100%'>
              <Col span={6} style={{ margin: '0 0 8px 0' }}>
                <LargeTextWithLabel title={{ text: 'ต้นทุน' }} content={{ text: `${numeral(inventoryOptions[0].initialCost).format('0,0.00')} บาท` }} />
              </Col>
              <Col span={6} style={{ margin: '0 0 8px 0' }}>
                <LargeTextWithLabel title={{ text: 'ราคาซื้อสุทธิ' }} content={{ text: `${numeral(inventoryOptions[0].buyPrice).format('0,0.00')} บาท` }} margin='0 40px 0 0' />
              </Col>
              <Col span={6} style={{ margin: '0 0 8px 0' }}>
                <LargeTextWithLabel title={{ text: 'ราคาขาย' }} content={{ text: `${numeral(inventoryOptions[0].salesPrice).format('0,0.00')} บาท` }} />
              </Col>
            </Div>
          </Div>
          <Div>
            <Image src={inventoryOptions[0].url || imageNotAvailable} alt='' />
          </Div>
        </Div>
      }
    </Div>
)

const SerialTable = ({ serial, id }) => {
  const [current, setCurrent] = useState(0)
  const [importModal, setImportModal] = useState(false)
  const [mtModal, setMtModal] = useState(false)
  const { loading: warehousesLoading, data: warehousesData, error: warehousesError } = useQuery(WAREHOUSES)
  const [check, setCheck] = useState([])
  const [filter, setFilter] = useState()
  const [checkAll, setCheckAll] = useState(false)
  const [columns, setColumns] = useState(content.columns)
  const [serials, setSerials] = useState([])
  const [totalFilter, setTotalFilter] = useState([])


  const {
    data, loading, error, fetchMore, refetch,
  } = useQuery(TIRE_SERIAL_NUMBER_LIST, {
    fetchPolicy: 'network-only',
    variables: {
      limit: 5,
      offset: 5 * current,
      serialNumber: serial,
      inventoryOptionId: id,
      ...filter,
    },
  })
  useEffect(() => {
    setColumns(columnConfig({
      checkAll,
    }))
    if (data && data.TireSerialNumberList && data.TireSerialNumberList.lists) {
      const rawData = {
        lists: data.TireSerialNumberList.lists,
        totalFilter: data.TireSerialNumberList.totalFilter,
      }
      if (rawData.lists.length === 0 && serials.length > 0) {
        setSerials([])
        setTotalFilter(0)
        setCheck([])
        setCheckAll(false)
        return
      }
      const isDifference = _.difference(rawData.lists, serials).length > 0
      if (isDifference) {
        setSerials(rawData.lists)
        setTotalFilter(rawData.totalFilter)
        if (check.length > 0 && rawData.lists.length > 0 && rawData.lists.filter(s => check.find(c => c.id === s.id)).length === rawData.lists.length) {
          setCheckAll(true)
          setColumns(columnConfig({
            checkAll,
          }))
        }
      }
    }
  }, [data, loading, current, checkAll, check, serials, filter])
  const [doAction, { loading: mutationLoading }] = useMutation(IMPORT_TIRE)
  const [doTransfer, { loading: mutationMultipleTransferLoading }] = useMutation(MULTIPLETRANSFER_TIRE)

  if (warehousesLoading && _.isEmpty(warehousesData)) return <Loading center='true' />
  return (
    <Wrapper overflow padding='0 0 40px 0'>
      {loading && _.isEmpty(data) && <Loading center='true' />}
      {warehousesLoading && _.isEmpty(warehousesData) && <Loading center='true' />}
      {(!loading || !_.isEmpty(data))
        && <Div display='flex' flexDirection='column'>
          <Div display='flex' flexDirection='row' justifyContent='flex-end' alignItems='center'>
            <KonsysButton text='นำเข้ารายการยาง' icon='fas fa-file-import' onClick={() => setImportModal(true)} margin='0 8px'
              loading={mutationLoading}
              disabled={
                mutationLoading
              } />
            <KonsysButton text='ย้ายสาขา' icon='fas fa-file-import' onClick={() => setMtModal(true)} margin='0 8px'
              loading={mutationLoading || mutationMultipleTransferLoading}
              disabled={
                mutationMultipleTransferLoading
                || mutationLoading
              } />
          </Div>
          <ReactTable
            className='table'
            data={serials || []} // *
            resizable={false}
            columns={columns} // *
            minRows={5}
            manual
            // defaultPageSize={10}
            showPageSizeOptions={false}
            getTdProps={() => ({
              disabled: true, check, setCheck, tireLists: serials, warehousesData, checkAll, refetch,
            })} // *
            getTrProps={(state, rowInfo) => { // *
              if (rowInfo) {
                return {
                  style: {
                    padding: '8px 0',
                    backgroundColor: '#ffffff',
                    borderLeft: `3px solid ${color.primaryColor}`,
                  },
                }
              } return {}
            }}
            setCheck={setCheck}
            check={check}
            previousText='ก่อนหน้า'
            nextText='ถัดไป'
            pageText='หน้า'
            ofText='จาก'
            page={current}
            pages={Math.ceil(totalFilter / 5)}
            onPageChange={(page) => {
              setCurrent(page)
              setCheckAll(false)
              refetch(filter)
            }}
            onFilteredChange={async (newFiltered, info) => {
              if (info.id === 'checkbox') {
                if (serials.length === 0) return
                if (_.find(newFiltered, v => v.id === 'checkbox').value.target.checked) {
                  setCheck(_.concat(check, serials.filter(curr => !check.find(c => c.id === curr.id))))
                  setCheckAll(true)
                } else {
                  setCheck(
                    check.filter(checks => !serials.find(curr => curr.id === checks.id)),
                  )
                  setCheckAll(false)
                }
              } else {
                const newOjb = {
                  serialNumber: '',
                  status: 'ALL',
                  plateNumber: '',
                }
                await newFiltered.forEach((v) => {
                  if (v.id === 'inventory.sku') {
                    Object.assign(newOjb, { sku: v.value })
                  } else if (v.id === 'Tire.TireType.name') {
                    Object.assign(newOjb, { tireTypeName: v.value })
                  } else if (v.id === 'TruckTires.Truck.plateNumber') {
                    Object.assign(newOjb, { plateNumber: v.value })
                  } else if (v.id === 'TrailerTires.Trailer.trailerPlate') {
                    Object.assign(newOjb, { trailerPlate: v.value })
                  } else {
                    Object.assign(newOjb, { [v.id]: v.value })
                  }
                })
                setCurrent(0)
                setCheck([])
                setFilter(newOjb)
                refetch(newOjb)
              }
            }}
            onSortedChange={async (newSorted) => {
              setCurrent(0)
              refetch({
                orderBy: newSorted[0].desc ? 'DESC' : 'ASC',
                orderField: newSorted[0].id,
              })
            }}
          />
          {
            loading && <Div margin='32px 0 0'><Loading center='true' /></Div>
          }

        </Div>
      }
      {(!warehousesLoading || !_.isEmpty(warehousesData))
        && <ImportSerialModal
          doAction={doAction}
          loading={mutationLoading}
          importModal={importModal}
          setImportModal={setImportModal}
          warehousesData={warehousesData}
          id={id}
        />
      }
      {(!warehousesLoading || !_.isEmpty(warehousesData))
        && <MultipleTransferStockModal
          doTransfer={doTransfer}
          loading={mutationMultipleTransferLoading}
          mtModal={mtModal}
          setMtModal={setMtModal}
          warehousesData={warehousesData}
          check={check}
          refetch={refetch}
          filter={filter}
          id={id}
          serial={serial}
          setCheck={setCheck}
          setCheckAll={setCheckAll}
        />
      }

    </Wrapper>
  )
}

// Variant type
const VariantDetail = ({ data, serial }) => {
  const [isOpenVariant, setIsOpenVariant] = useState(true)
  const [isOpenSerialTable, setIsOpenSerialTable] = useState(true)
  return (
    <Div>
      <Info data={data} />
      {/* <AttributesList data={data} /> */}
      <Collapse open={isOpenSerialTable} text='รายการยาง' onClick={() => setIsOpenSerialTable(!isOpenSerialTable)} fullHeight={true} margin='8px 0'>
        {
          data.inventoryOptions[0]
          && <SerialTable id={data.inventoryOptions[0].id} serial={serial} />
        }
      </Collapse>
      <Collapse open={isOpenVariant} text='สต๊อกในแต่ละสถานที่เก็บ' onClick={() => setIsOpenVariant(!isOpenVariant)} fullHeight={true} margin='8px 0'>
        {
          data.inventoryOptions.map((v, i) => (
            <Div key={i}>
              {
                v.stockLocation.map((value, index) => (
                  <Div key={index} padding='16px' style={{ border: `1px solid ${theme.color.lightBlue}`, borderRadius: 5, background: '#fafafa' }} margin='4px 0 0'>
                    <Row key={i} type='flex' style={{ margin: '8px 0' }}>
                      <Col span={8} style={{ margin: '0 0 8px 0' }}>
                        <LargeTextWithLabel title={{ text: 'สถานที่เก็บ' }} content={{ text: value.warehouse ? value.warehouse.warehouseName : 'ไม่ระบุ', bold: true }} />
                      </Col>
                      <Col span={8} style={{ margin: '0 0 8px 0' }}>
                        <LargeTextWithLabel title={{ text: 'รหัสชั้นวาง' }} content={{ text: value.shelf, bold: true }} />
                      </Col>
                    </Row>
                    <Row>
                      <Col span={6} style={{ margin: '0 0 8px 0' }}>
                        <ComponentWithLabelLarge title={{ text: 'สินค้าสต๊อกใหม่ในคลัง' }}>
                          <P bold>{value.isNewstock}</P><P margin='0 0 0 8px'>ชิ้น</P>
                        </ComponentWithLabelLarge>
                      </Col>
                      <Col span={6} style={{ margin: '0 0 8px 0' }}>
                        <ComponentWithLabelLarge title={{ text: 'สินค้าสต๊อกเก่าในคลัง' }}>
                          <P bold>{value.isOldstock}</P><P margin='0 0 0 8px'>ชิ้น</P>
                        </ComponentWithLabelLarge>
                      </Col>
                      <Col span={6} style={{ margin: '0 0 8px 0' }}>
                        <ComponentWithLabelLarge title={{ text: 'สินค้าใช้อยู่ในคลัง' }}>
                          <P bold>{value.isUsing}</P><P margin='0 0 0 8px'>ชิ้น</P>
                        </ComponentWithLabelLarge>
                      </Col>
                      <Col span={6} style={{ margin: '0 0 8px 0' }}>
                        <ComponentWithLabelLarge title={{ text: 'สินค้ารอจำหน่ายในคลัง' }}>
                          <P bold>{value.isWaitforsale}</P><P margin='0 0 0 8px'>ชิ้น</P>
                        </ComponentWithLabelLarge>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={6} style={{ margin: '0 0 8px 0' }}>
                        <ComponentWithLabelLarge title={{ text: 'สินค้าขายแล้วในคลัง' }}>
                          <P bold>{value.isSold}</P><P margin='0 0 0 8px'>ชิ้น</P>
                        </ComponentWithLabelLarge>
                      </Col>
                      <Col span={6} style={{ margin: '0 0 8px 0' }}>
                        <ComponentWithLabelLarge title={{ text: 'สินค้านำออกในคลัง' }}>
                          <P bold>{value.isLost}</P><P margin='0 0 0 8px'>ชิ้น</P>
                        </ComponentWithLabelLarge>
                      </Col>
                      <Col span={6} style={{ margin: '0 0 8px 0' }}>
                        <ComponentWithLabelLarge title={{ text: 'สินค้าทั้งหมดในคลัง' }}>
                          <P bold>{value.quantity}</P><P margin='0 0 0 8px'>ชิ้น</P>
                        </ComponentWithLabelLarge>
                      </Col>
                    </Row>
                  </Div>
                ))
              }
              {
                // _.size([...new Array(5)]) - 1 !== i && <Divider />
                _.size([...new Array(5)]) - 1 !== i && <Wrapper />
              }
            </Div>
          ))
        }
      </Collapse>
    </Div>
  )
}

const ImportSerialModal = ({
  doAction, loading, importModal, setImportModal, warehousesData, id,
}) => {
  const [file, setFile] = useState()
  const [warehouseId, setWarehouseId] = useState()
  return (
    <Modal
      title="นำเข้ารายการยาง"
      visible={importModal}
      destroyOnClose={true}
      onCancel={() => {
        setImportModal(false)
        setWarehouseId()
        setFile()
      }}
      onOk={() => {
        doAction({
          variables: {
            warehouseId,
            files: file[0],
            inventoryOptionId: id,
          },
        }).then((resp) => {
          const KEY = 'ImportTireSerialNumber'
          if (resp.data[KEY].success) {
            message.success(resp.data[KEY].message)
          } else message.error(resp.data[KEY].message)
        })
        setWarehouseId()
        setFile()
        setImportModal(false)
      }}
      okButtonProps={{
        loading,
        disabled: _.isNaN(warehouseId),
      }}
      cancelButtonProps={{
        disabled: loading,
      }}
    >
      <Div display='flex' flexDirection='row' alignItems='center' margin='0 0 16px'>
        <P margin='8px 32px 16px 0'>เลือกคลังสินค้า</P>
        <Select
          dropdown
          maxHeight='none'
          style={{ width: '500px' }}
          onChange={e => setWarehouseId(e)}
        >
          {
            warehousesData.warehouseList.data.list.map(v => <Select.Option key={v.id} value={v.id}>{v.warehouseName}</Select.Option>)
          }
        </Select>
      </Div>
      <Upload
        showUploadList={{
          showRemoveIcon: true,
        }}
        // disabled={props.disabled}
        customRequest={() => null}
        processData={false}
        fileList={file}
        onChange={(e) => {
          let fileList = [...e.fileList]
          fileList = fileList.slice(-1)
          setFile(fileList.map(v => v.originFileObj))
        }}
        multiple={false}
        onRemove={e => setFile(_.remove(_.cloneDeep(file), obj => obj.uid !== e.uid))}
      // defaultFileList={_.size(file) > 0 && file.map(v => ({
      //   name: v.filename,
      //   url: v.url,
      //   uid: v.url,
      // }))}
      >
        <KonsysButton inverse small text={'อัพโหลดไฟล์'} icon='far fa-file-upload' disabled={loading} />
      </Upload>
    </Modal>
  )
}
const MultipleTransferStockModal = ({
  doTransfer, loading, mtModal, setMtModal, warehousesData, id, filter,
}) => {
  const [warehouseId, setWarehouseId] = useState()
  const [oldWarehouseId, setOldWarehouseId] = useState()
  const [check, setCheck] = useState([])
  const {
    data, loading: serialLoading, error, fetchMore, refetch,
  } = useQuery(TIRE_SERIAL_NUMBER_LIST, {
    fetchPolicy: 'network-only',
    variables: {
      limit: 10,
      inventoryOptionId: id,
      warehouseId: oldWarehouseId,
      ...filter,
    },
  })
  return (
    <Modal
      title="ย้ายโกดังยาง"
      visible={mtModal}
      destroyOnClose={true}
      width='800px'
      onCancel={() => {
        setMtModal(false)
        setWarehouseId()
        setCheck([])
      }}
      onOk={() => {
        doTransfer({
          variables: {
            warehouseId,
            inventoryOptionId: id,
            sourceWarehouseId: oldWarehouseId,
            ids: check.map(c => c.id),
          },
        }).then((resp) => {
          const KEY = 'MultipleTransferStockSerialNumber'
          if (resp.data[KEY].success) {
            setWarehouseId()
            setCheck([])
            setMtModal(false)
            message.success(resp.data[KEY].message)
          } else message.error(resp.data[KEY].message)
        })
      }}
      okButtonProps={{
        loading,
        disabled: _.isNaN(warehouseId)
        || _.size(_.filter(check, o => _.isUndefined(o.serialNumber))) > 0
        || check.length === 0,
      }}
      cancelButtonProps={{
        disabled: loading,
      }}
    >
      <Div >
        <Div display='flex' flexDirection='row' alignItems='center' margin='0 0 16px'>
          <P margin='8px 32px 16px 0' style={{ width: '300px' }}>เลือกคลังสินค้าต้นทาง</P>
          <Select
            dropdown
            maxHeight='none'
            style={{ width: '500px' }}
            onChange={(e) => {
              setOldWarehouseId(e)
              setCheck([])
            }}
          >
            {
              warehousesData.warehouseList.data.list.map(v => <Select.Option key={v.id} value={v.id}>{v.warehouseName}</Select.Option>)
            }
          </Select>
        </Div>
        <Div display='flex' flexDirection='row' alignItems='center' margin='0 0 16px'>
          <P margin='8px 32px 16px 0' style={{ width: '300px' }}>เลือกคลังสินค้าปลายทาง</P>
          <Select
            dropdown
            maxHeight='none'
            style={{ width: '500px' }}
            onChange={e => setWarehouseId(e)}
          >
            {
              warehousesData.warehouseList.data.list.map(v => <Select.Option key={v.id} value={v.id}>{v.warehouseName}</Select.Option>)
            }
          </Select>
        </Div>
        <Div display='flex' flexDirection='row' alignItems='center' justifyContent='flex-end' margin='0 0 16px'>
          <P margin='8px 16px 0' style={{ width: '300px', textAlign: 'end' }}>จำนวนทั้งหมด {check.length} เส้น</P>
        </Div>
        <Div display='flex' flexDirection='column' justifyContent='center'>
          <Row gutter={8} style={{ marginBottom: 8 }} align='middle' type='flex'>
            <Col span={2}>
              <P>ลำดับที่</P>
            </Col>
            <Col span={8}>
              <P>เบอร์ยาง</P>
            </Col>
            <Col span={8}>
              <P>คลังสินค้า</P>
            </Col>
            <Col span={5}>
              <P>สถานะ</P>
            </Col>
          </Row>
          {(!serialLoading || !_.isEmpty(data))
            && check.map((v, index) => (
              <Row key={v.id} gutter={8} style={{ marginBottom: 8 }} align='middle' type='flex'>
              <Col span={2}>
                <P>{index + 1}</P>
              </Col>
                <Col span={8}>
                  <Select
                    showSearch
                    style={{ width: '100%' }}
                    loading={serialLoading}
                    value={v.serialNumber}
                    onSelect={(e) => {
                      if (!_.some(check, { serialNumber: e })) {
                        const selected = _.find(data.TireSerialNumberList.lists, o => o.serialNumber === e)
                        const newCheck = _.cloneDeep(check)
                        newCheck[index].id = selected.id
                        newCheck[index].serialNumber = e
                        newCheck[index].status = selected.status
                        newCheck[index].warehouseName = selected.Warehouse.warehouseName
                        setCheck([...newCheck])
                      }
                    }}
                    onSearch={e => refetch({ serialNumber: e })}
                    placeholder='พิมพ์เพื่อค้นหา'
                  >
                    {
                      data.TireSerialNumberList.lists.map(u => <Select.Option key={u.id} value={u.serialNumber}>{u.serialNumber}</Select.Option>)
                    }
                  </Select>
                </Col>
                <Col span={8}>
                  <P>{v.warehouseName}</P>
                </Col>
                <Col span={5}>
                  <P>{STATUSTEXTSELECTOR(v.status)}</P>
                </Col>
                <Col span={1}><Icon
                  className="dynamic-delete-button"
                  type="minus-circle-o"
                  onClick={() => {
                    const newCheck = _.cloneDeep(check)
                    _.remove(newCheck, n => n.id === v.id)
                    setCheck(newCheck)
                  }}
                /></Col>
              </Row>
            ))
          }
          <Button type="dashed" disabled={_.isUndefined(oldWarehouseId)} onClick={() => {
            setCheck([...check, {
              id: check.length,
            }])
          }}>
          <Icon type="plus" /> เพิ่มยางที่ย้าย
          </Button>
        </Div>
        {/* <Div display='block' flexDirection='row' alignItems='center' margin='0 0 16px'>
          <P display='block' margin='8px 32px 16px 0'>รายการยางที่เลือก ( {numeral(check.length).format('0,0')} รายการ )</P>
          <P display='block' margin='8px 32px 16px 0'>
            {
              check.map(d => d.serialNumber).join(' , ')
            }
          </P>
        </Div> */}
      </Div>
    </Modal>
  )
}
export default ({ props }) => {
  const { loading: infoLoading, data: infoData, error: infoError } = useQuery(TIRE_INVENTORY, { variables: { id: props.match.params.id } })
  const serial = props.location.search.substring(8) === 'undefined' ? '' : props.location.search.substring(8)
  if (infoLoading && _.isUndefined(infoData)) return <Loading center='true' />
  const data = infoData.TireInfo
  return <VariantDetail data={data} serial={serial} />
}
